import { useCallback } from 'react';
import swal from 'sweetalert2';
import useContext from './useContext';
import copy from '../utils/copy';

export default function useShareModal() {
  const { condominium } = useContext();

  const trigger = useCallback(async () => {
    const firstPart = `Para participar das assembleias do condomínio ${condominium.name}, entre no link e cadastre-se`;
    const { value } = await swal.fire({
      customClass: {
        confirmButton: 'bg-primary',
      },
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Copiar',
      cancelButtonText: 'Cancelar',
      title: 'Convidar condôminos ',
      html: `
            <p>Convide os condôminos pelo link abaixo: </p>
           
            <small class="text-italic">
              ${window.location.origin}/${condominium.referral}
            </small>
            `,

      footer:
        '<p>Para segurança do condomínio, é necessário que você aprove o cadastro de cada condômino, fique de olho no seu e-mail.</p>',
    });
    if (value) {
      copy(`${firstPart} ${window.location.origin}/${condominium.referral}`);
    }
  }, [condominium]);

  return trigger;
}
